export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
